import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";

const BonusMasterPrint = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [companyInfo] = useState({
    name: "Nissi Infotech",
    subtitle: "Nissi",
    type: "CIVIL CONSTRUCTION",
    address: "3/42-12, Nagappa colony, Kavundampalayam, Coimbatore-30, Tamil Nadu, India",
    phone: "Phone No: 9003744644",
    email: "infraconsoft-implementation@nissiinfotech.com"
  });

  useEffect(() => {
    loadPrintData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadPrintData = () => {
    try {
      const storedData = localStorage.getItem("bonusMasterPrintData");
      
      if (!storedData) {
        alert("No data available for printing. Please search first.");
        window.close();
        return;
      }

      const parsedData = JSON.parse(storedData);
      
      if (!parsedData || parsedData.length === 0) {
        alert("No records found to print");
        window.close();
        return;
      }

      setData(parsedData);
    } catch (err) {
      console.error("Print Data Error:", err);
      alert("Failed to load print data");
      window.close();
    } finally {
      setLoading(false);
    }
  };

  // Auto print when data loads
  useEffect(() => {
    if (!loading && data.length > 0) {
      setTimeout(() => {
        window.print();
      }, 500);
    }
  }, [loading, data]);

  const getFinancialYearDisplay = () => {
    const fromYear = localStorage.getItem("bonusFrmYear") || "";
    const toYear = localStorage.getItem("bonusToYear") || "";
    
    if (fromYear && toYear) {
      return `${fromYear} TO ${toYear}`;
    }
    return "";
  };

  const calculateColumnTotal = (field) => {
    return data.reduce((sum, row) => sum + (parseFloat(row[field]) || 0), 0);
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-white">
        <div className="text-center">
          <Loader2 className="w-12 h-12 animate-spin mx-auto text-blue-600" />
          <p className="mt-4 text-gray-600 font-semibold">Loading print data...</p>
        </div>
      </div>
    );
  }

  return (
    <>
      {/* Print Styles */}
      <style>{`
        @media print {
          @page {
            size: A3 landscape;
            margin: 8mm;
          }
          
          body {
            margin: 0;
            padding: 0;
          }
          
          .no-print {
            display: none !important;
          }
          
          .print-container {
            width: 100%;
            font-family: Arial, sans-serif;
          }
          
          table {
            page-break-inside: auto;
          }
          
          tr {
            page-break-inside: avoid;
            page-break-after: auto;
          }
          
          thead {
            display: table-header-group;
          }
          
          tfoot {
            display: table-footer-group;
          }
        }
        
        @media screen {
          .print-container {
            max-width: 1800px;
            margin: 20px auto;
            padding: 20px;
            background: white;
            box-shadow: 0 0 10px rgba(0,0,0,0.1);
          }
        }
      `}</style>

      <div className="print-container">
        {/* Header */}
        <div style={{ border: '2px solid #000', padding: '8px', marginBottom: '8px' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <tbody>
              <tr>
                <td style={{ width: '120px', textAlign: 'center', verticalAlign: 'middle' }}>
                  <div style={{ 
                    width: '100px', 
                    height: '60px', 
                    border: '2px solid #000',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto',
                    backgroundColor: '#000',
                    color: '#fff',
                    fontWeight: 'bold',
                    fontSize: '9px',
                    flexDirection: 'column'
                  }}>
                    <div>NISSI</div>
                    <div>INFOTECH</div>
                  </div>
                </td>
                <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                  <h2 style={{ margin: '0', fontSize: '14px', fontWeight: 'bold' }}>
                    {companyInfo.name}
                  </h2>
                  <p style={{ margin: '1px 0', fontSize: '10px' }}>{companyInfo.subtitle}</p>
                  <p style={{ margin: '1px 0', fontSize: '10px', fontWeight: 'bold' }}>
                    {companyInfo.type}
                  </p>
                  <p style={{ margin: '1px 0', fontSize: '8px' }}>{companyInfo.address}</p>
                  <p style={{ margin: '1px 0', fontSize: '8px' }}>
                    {companyInfo.phone} - {companyInfo.email}
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Title */}
        <div style={{ 
          border: '2px solid #000', 
          padding: '6px', 
          textAlign: 'center',
          marginBottom: '8px',
          fontWeight: 'bold',
          fontSize: '11px'
        }}>
          BONUS MASTER LIST FOR THE YEAR OF {getFinancialYearDisplay()}
        </div>

        {/* Data Table */}
        <table style={{ 
          width: '100%', 
          borderCollapse: 'collapse', 
          border: '2px solid #000',
          fontSize: '7px'
        }}>
          <thead>
            <tr style={{ backgroundColor: '#f0f0f0' }}>
              <th style={{ border: '1px solid #000', padding: '4px', textAlign: 'center', width: '20px' }}>
                S.No
              </th>
              <th style={{ border: '1px solid #000', padding: '4px', textAlign: 'center', width: '45px' }}>
                Emp Code
              </th>
              <th style={{ border: '1px solid #000', padding: '4px', textAlign: 'left', width: '100px' }}>
                Employee Name
              </th>
              <th style={{ border: '1px solid #000', padding: '4px', textAlign: 'center', width: '80px' }}>
                Designation
              </th>
              <th style={{ border: '1px solid #000', padding: '4px', textAlign: 'center', width: '50px' }}>
                DOJ
              </th>
              <th style={{ border: '1px solid #000', padding: '4px', textAlign: 'center', width: '60px' }}>
                A/C No.
              </th>
              <th style={{ border: '1px solid #000', padding: '4px', textAlign: 'right', width: '40px' }}>
                Oct
              </th>
              <th style={{ border: '1px solid #000', padding: '4px', textAlign: 'right', width: '40px' }}>
                Nov
              </th>
              <th style={{ border: '1px solid #000', padding: '4px', textAlign: 'right', width: '40px' }}>
                Dec
              </th>
              <th style={{ border: '1px solid #000', padding: '4px', textAlign: 'right', width: '40px' }}>
                Jan
              </th>
              <th style={{ border: '1px solid #000', padding: '4px', textAlign: 'right', width: '40px' }}>
                Feb
              </th>
              <th style={{ border: '1px solid #000', padding: '4px', textAlign: 'right', width: '40px' }}>
                Mar
              </th>
              <th style={{ border: '1px solid #000', padding: '4px', textAlign: 'right', width: '40px' }}>
                Apr
              </th>
              <th style={{ border: '1px solid #000', padding: '4px', textAlign: 'right', width: '40px' }}>
                May
              </th>
              <th style={{ border: '1px solid #000', padding: '4px', textAlign: 'right', width: '40px' }}>
                Jun
              </th>
              <th style={{ border: '1px solid #000', padding: '4px', textAlign: 'right', width: '40px' }}>
                Jul
              </th>
              <th style={{ border: '1px solid #000', padding: '4px', textAlign: 'right', width: '40px' }}>
                Aug
              </th>
              <th style={{ border: '1px solid #000', padding: '4px', textAlign: 'right', width: '40px' }}>
                Sep
              </th>
              <th style={{ border: '1px solid #000', padding: '4px', textAlign: 'right', width: '45px' }}>
                Total
              </th>
              <th style={{ border: '1px solid #000', padding: '4px', textAlign: 'right', width: '40px' }}>
                Batta
              </th>
              <th style={{ border: '1px solid #000', padding: '4px', textAlign: 'right', width: '45px' }}>
                Batta<br/>Bonus
              </th>
              <th style={{ border: '1px solid #000', padding: '4px', textAlign: 'right', width: '50px' }}>
                Total<br/>Bonus
              </th>
              <th style={{ border: '1px solid #000', padding: '4px', textAlign: 'center', width: '60px' }}>
                Location
              </th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, idx) => (
              <tr key={idx}>
                <td style={{ border: '1px solid #000', padding: '3px', textAlign: 'center' }}>
                  {idx + 1}
                </td>
                <td style={{ border: '1px solid #000', padding: '3px', textAlign: 'center' }}>
                  {row.EmployeeCode || ''}
                </td>
                <td style={{ border: '1px solid #000', padding: '3px', textAlign: 'left' }}>
                  {row["Employee Name"] || ''}
                </td>
                <td style={{ border: '1px solid #000', padding: '3px', textAlign: 'center' }}>
                  {row.Designation || ''}
                </td>
                <td style={{ border: '1px solid #000', padding: '3px', textAlign: 'center' }}>
                  {row.DOJ || ''}
                </td>
                <td style={{ border: '1px solid #000', padding: '3px', textAlign: 'center' }}>
                  {row["A/C No."] || ''}
                </td>
                <td style={{ border: '1px solid #000', padding: '3px', textAlign: 'right' }}>
                  {parseFloat(row.October || 0).toFixed(2)}
                </td>
                <td style={{ border: '1px solid #000', padding: '3px', textAlign: 'right' }}>
                  {parseFloat(row.November || 0).toFixed(2)}
                </td>
                <td style={{ border: '1px solid #000', padding: '3px', textAlign: 'right' }}>
                  {parseFloat(row.December || 0).toFixed(2)}
                </td>
                <td style={{ border: '1px solid #000', padding: '3px', textAlign: 'right' }}>
                  {parseFloat(row.January || 0).toFixed(2)}
                </td>
                <td style={{ border: '1px solid #000', padding: '3px', textAlign: 'right' }}>
                  {parseFloat(row.February || 0).toFixed(2)}
                </td>
                <td style={{ border: '1px solid #000', padding: '3px', textAlign: 'right' }}>
                  {parseFloat(row.March || 0).toFixed(2)}
                </td>
                <td style={{ border: '1px solid #000', padding: '3px', textAlign: 'right' }}>
                  {parseFloat(row.April || 0).toFixed(2)}
                </td>
                <td style={{ border: '1px solid #000', padding: '3px', textAlign: 'right' }}>
                  {parseFloat(row.May || 0).toFixed(2)}
                </td>
                <td style={{ border: '1px solid #000', padding: '3px', textAlign: 'right' }}>
                  {parseFloat(row.June || 0).toFixed(2)}
                </td>
                <td style={{ border: '1px solid #000', padding: '3px', textAlign: 'right' }}>
                  {parseFloat(row.July || 0).toFixed(2)}
                </td>
                <td style={{ border: '1px solid #000', padding: '3px', textAlign: 'right' }}>
                  {parseFloat(row.August || 0).toFixed(2)}
                </td>
                <td style={{ border: '1px solid #000', padding: '3px', textAlign: 'right' }}>
                  {parseFloat(row.September || 0).toFixed(2)}
                </td>
                <td style={{ border: '1px solid #000', padding: '3px', textAlign: 'right', fontWeight: 'bold' }}>
                  {parseFloat(row.Total || 0).toFixed(2)}
                </td>
                <td style={{ border: '1px solid #000', padding: '3px', textAlign: 'right' }}>
                  {parseFloat(row.Batta || 0).toFixed(2)}
                </td>
                <td style={{ border: '1px solid #000', padding: '3px', textAlign: 'right' }}>
                  {parseFloat(row["Batta Bonus"] || 0).toFixed(2)}
                </td>
                <td style={{ border: '1px solid #000', padding: '3px', textAlign: 'right', fontWeight: 'bold' }}>
                  {parseFloat(row["Total Bonus"] || 0).toFixed(2)}
                </td>
                <td style={{ border: '1px solid #000', padding: '3px', textAlign: 'center' }}>
                  {row.Location || ''}
                </td>
              </tr>
            ))}

            {/* Total Row */}
            <tr style={{ fontWeight: 'bold', backgroundColor: '#f9f9f9' }}>
              <td colSpan={6} style={{ border: '1px solid #000', padding: '4px', textAlign: 'right' }}>
                Grand Total
              </td>
              <td style={{ border: '1px solid #000', padding: '4px', textAlign: 'right' }}>
                {calculateColumnTotal('October').toFixed(2)}
              </td>
              <td style={{ border: '1px solid #000', padding: '4px', textAlign: 'right' }}>
                {calculateColumnTotal('November').toFixed(2)}
              </td>
              <td style={{ border: '1px solid #000', padding: '4px', textAlign: 'right' }}>
                {calculateColumnTotal('December').toFixed(2)}
              </td>
              <td style={{ border: '1px solid #000', padding: '4px', textAlign: 'right' }}>
                {calculateColumnTotal('January').toFixed(2)}
              </td>
              <td style={{ border: '1px solid #000', padding: '4px', textAlign: 'right' }}>
                {calculateColumnTotal('February').toFixed(2)}
              </td>
              <td style={{ border: '1px solid #000', padding: '4px', textAlign: 'right' }}>
                {calculateColumnTotal('March').toFixed(2)}
              </td>
              <td style={{ border: '1px solid #000', padding: '4px', textAlign: 'right' }}>
                {calculateColumnTotal('April').toFixed(2)}
              </td>
              <td style={{ border: '1px solid #000', padding: '4px', textAlign: 'right' }}>
                {calculateColumnTotal('May').toFixed(2)}
              </td>
              <td style={{ border: '1px solid #000', padding: '4px', textAlign: 'right' }}>
                {calculateColumnTotal('June').toFixed(2)}
              </td>
              <td style={{ border: '1px solid #000', padding: '4px', textAlign: 'right' }}>
                {calculateColumnTotal('July').toFixed(2)}
              </td>
              <td style={{ border: '1px solid #000', padding: '4px', textAlign: 'right' }}>
                {calculateColumnTotal('August').toFixed(2)}
              </td>
              <td style={{ border: '1px solid #000', padding: '4px', textAlign: 'right' }}>
                {calculateColumnTotal('September').toFixed(2)}
              </td>
              <td style={{ border: '1px solid #000', padding: '4px', textAlign: 'right' }}>
                {calculateColumnTotal('Total').toFixed(2)}
              </td>
              <td style={{ border: '1px solid #000', padding: '4px', textAlign: 'right' }}>
                {calculateColumnTotal('Batta').toFixed(2)}
              </td>
              <td style={{ border: '1px solid #000', padding: '4px', textAlign: 'right' }}>
                {calculateColumnTotal('Batta Bonus').toFixed(2)}
              </td>
              <td style={{ border: '1px solid #000', padding: '4px', textAlign: 'right' }}>
                {calculateColumnTotal('Total Bonus').toFixed(2)}
              </td>
              <td style={{ border: '1px solid #000', padding: '4px' }}></td>
            </tr>
          </tbody>
        </table>

        {/* Print Button (Only visible on screen) */}
        <div className="no-print" style={{ marginTop: '20px', textAlign: 'center' }}>
          <button
            onClick={() => window.print()}
            style={{
              padding: '10px 30px',
              backgroundColor: '#3b82f6',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: 'bold',
              marginRight: '10px'
            }}
          >
            Print Report
          </button>
          <button
            onClick={() => window.close()}
            style={{
              padding: '10px 30px',
              backgroundColor: '#6b7280',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: 'bold'
            }}
          >
            Close Window
          </button>
        </div>
      </div>
    </>
  );
};

export default BonusMasterPrint;
